export const LOGO_ANIMATION_DELAY = 300
export const TOTAL_TIME_IN_LOGO = 6000
export const INTERSTITIAL_STEP_TIME = 800
